export default function () {
    return {
        items: [
            {
                text: 'Admin',
                value: 'admin',
                roleToSave: 'Admin'
            },
            {
                text: 'Operator',
                value: 'operator',
                roleToSave: 'Operator'
            },
            {
                text: 'Team Lead',
                value: 'teamLead',
                roleToSave: 'TeamLead'
            },
            {
                text: 'RRD',
                value: 'rrd',
                roleToSave: 'RRD'
            },
            {
                text: 'Account Admin',
                value: 'accountAdmin',
                roleToSave: 'AccountAdmin'
            },
            {
                text: 'Trade Investigations',
                value: 'tradeInvestigations',
                roleToSave: 'TradeInvestigations'
            }
        ]
    };
}



// WEBPACK FOOTER //
// ./Client/app/common/services/userRoles.js